import styled from "styled-components";
import { getColor, getSize, responsive } from "~/helpers/style";
import Button from "../ui/Button";

export const StepTitle = styled.h2`
  color: ${getColor("text")};
  font-size: ${getSize(1.8)};
  font-weight: 700;
  margin: 0;
  font-family: Ubuntu;

  ${responsive("tablet", true)} {
    font-size: ${getSize(1.2)};
  }

  ${responsive("tablet")} {
    font-size: ${getSize(1.4)};
    margin: ${getSize(1.3)} 0;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${getSize(2.0)};

  ${responsive("tablet", true)} {
    gap: ${getSize(1.0)};
  }

  ${responsive("tablet")} {
    grid-template-columns: 1fr 1fr;
    gap: ${getSize(2.0)};
  }
`;

export const CardCategory = styled.div`
  display: flex;
  gap: ${getSize(1.0)};
  padding: ${getSize(1.2)} ${getSize(2.3)};
  border: 1px solid ${getColor("border")};
  border-radius: ${getSize(0.8)};
  align-items: center;
  font-size: ${getSize(1.4)};
  color: ${getColor("text")};
  cursor: pointer;
  font-weight: 500;
  width: 100%;
  transition: border-color 0.2s;

  ${responsive("tablet", true)} {
    gap: ${getSize(0.6)};
    padding: ${getSize(0.6)} ${getSize(1.2)};
    border-radius: ${getSize(0.6)};
    font-size: ${getSize(1.1)};
  }

  ${responsive("tablet")} {
    font-size: ${getSize(1.6)};
    padding: ${getSize(1.8)} ${getSize(2.3)};
  }

  &:hover {
    background-color: ${getColor("background")};
    border: 0.74px solid #1a004d;
  }

  &.active {
    border: 1px solid ${getColor("primary")};
  }
`;

export const ButtonFixedContainer = styled.div`
  padding: ${getSize(1.3)};
  background-color: ${getColor("background")};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const LoadingContainer = styled.div`
  > div {
    height: 10px;
    width: 20px;
    top: 0;

    > svg {
      margin: unset !important;
    }
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  height: 180px;
  width: 100%;
  width: 400px;
  align-items: center;
  justify-content: center;
`;

export const SkipButton = styled(Button)`
  border: 1px solid #8383830f;
  box-shadow: 0px 1px 2px 0px #1018280d;
  color: var(--light-dark, #2e2e2e);
  font-weight: 500;

  :hover {
    background-color: ${getColor("background")};
  }
`;

export const CategoryModalContent = styled.div`
  white-space: nowrap;
  width: 100%;
  overflow: visible;

  ${responsive("laptopL", true)} {
    width: 100%;
  }
`;

export const PrimaryCategoriesContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${getSize(1.4)};
  width: 100%;

  ${responsive("tablet")} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const PrimaryCategoryCard = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  border: 1px solid ${getColor("border")};
  border-radius: ${getSize(0.8)};
  padding: ${getSize(1.8)} ${getSize(2.3)};
  background: ${getColor("white")};
  color: ${getColor("text")};
  font-size: ${getSize(1.8)};
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.2s;

  &.active {
    border-color: ${getColor("primary")};
  }

  ${responsive("tablet", true)} {
    font-size: ${getSize(1.1)};
    padding: ${getSize(0.8)} ${getSize(1.2)};
  }
`;

export const OtherDropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const OtherDropdownButton = styled.button`
  width: 100%;
  border: 1px solid ${getColor("border")};
  border-radius: ${getSize(0.8)};
  padding: ${getSize(1.8)} ${getSize(2.3)};
  background: ${getColor("white")};
  color: ${getColor("text")};
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${getSize(1.8)};
  cursor: pointer;

  &.open {
    border-color: ${getColor("border")};
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  ${responsive("tablet", true)} {
    font-size: ${getSize(1.1)};
    padding: ${getSize(0.8)} ${getSize(1.2)};
  }
`;

export const OtherDropdownLabel = styled.span`
  display: flex;
  align-items: center;
  gap: ${getSize(0.8)};

  &.hasSelection {
    color: ${getColor("primary")};
  }
`;

export const ClearOtherSelectionButton = styled.button`
  display: inline-flex;
  align-items: center;
  border: none;
  background: transparent;
  color: ${getColor("primary")};
  cursor: pointer;
  padding: 0;
`;

export const OtherDropdownMenu = styled.div`
  position: static;
  width: 100%;
  background: ${getColor("white")};
  border: 1px solid ${getColor("border")};
  border-top: none;
  border-bottom-left-radius: ${getSize(0.8)};
  border-bottom-right-radius: ${getSize(0.8)};
  max-height: 320px;
  overflow-y: auto;
  z-index: 1000;
  padding: ${getSize(0.8)};
`;

export const OtherDropdownPortalMenu = styled.div`
  position: fixed;
  background: ${getColor("white")};
  border: 1px solid ${getColor("border")};
  border-radius: ${getSize(0.8)};
  overflow-y: auto;
  z-index: 9999;
  padding: ${getSize(0.8)};
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
`;

export const OtherDropdownOption = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: ${getSize(1.2)} ${getSize(2.3)};
  font-size: ${getSize(1.8)};
  color: ${getColor("text")};
  cursor: pointer;
  border: 1px solid ${getColor("border")};
  border-radius: ${getSize(0.8)};
  margin-bottom: ${getSize(0.8)};

  &:hover {
    background: ${getColor("background")};
  }

  &.active {
    border-color: ${getColor("primary")};
  }

  &:last-child {
    margin-bottom: 0;
  }

  ${responsive("tablet", true)} {
    font-size: ${getSize(1.1)};
    padding: ${getSize(0.8)} ${getSize(1.2)};
  }
`;
